<template>
  <el-popover
    v-bind="$attrs"
    :popper-class="computedPopperClass"
    v-on="$listeners"
  >
    <div class="popover-image">
      <slot />
    </div>
    <slot
      slot="reference"
      name="reference"
    />
  </el-popover>
</template>

<script>
export default {
  name: 'RtPopover',
  props: {
    popperClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      defaultPopperClass: 'rt-xpc-box-shadow-base '
    };
  },
  computed: {
    computedPopperClass () {
      return this.defaultPopperClass + this.popperClass;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtPopover.vue?1f35eef2